import { OnboardingInputError, ValidateRequired } from "phoenix/onboarding/OnboardingTypes"
import { useFuturesOnboardingStore } from "../../Store"

export const TradingExperienceIsValid = () => getTradingExperienceErrors()?.length < 1
export const getTradingExperienceErrors = () => {
    const keys = [
        'data.tradingExperience.commoditiesYears',
        'data.tradingExperience.securitiesYears',
        'data.tradingExperience.otcYears',
        'data.tradingExperience.professionalTrader'
    ]
    const store = useFuturesOnboardingStore.getState()
    const _errors = []  as OnboardingInputError[]
    keys.forEach(key => {
        switch(key) {
            case  'data.tradingExperience.commoditiesYears':
            case  'data.tradingExperience.securitiesYears':
            case  'data.tradingExperience.otcYears':
            case  'data.tradingExperience.professionalTrader':
                _errors.push(ValidateRequired(store, key))
                break
    }})
    return _errors.filter(e => !!e);
}